import { withNaming } from '@bem-react/classname';

export const createBEMConstructor = withNaming({
  e: '__',
  m: '--',
  v: '_'
});
